export default "__VITE_ASSET__C$QjDSSO__"